import { type ReactElement, type ReactNode, useState } from 'react';
import { useNavigate } from 'react-router';
import { Button, Checkbox } from '@optimization/ssi-common';
import TermsOfUseContent from './terms-of-use-content';
import { acceptTermsOfUse, hasAcceptedTermsOfUse } from './terms-of-use-storage';
import styles from './style.module.scss';

interface TermsOfUseGateProperties {
  readonly children: ReactNode;
}

const TermsOfUseGate = ({ children }: TermsOfUseGateProperties): ReactElement => {
  const [hasAccepted, setHasAccepted] = useState(hasAcceptedTermsOfUse);
  const [isChecked, setIsChecked] = useState(false);
  const navigate = useNavigate();

  if (hasAccepted) {
    return <>{children}</>;
  }

  const handleAccept = (): void => {
    acceptTermsOfUse();
    setHasAccepted(true);
  };

  return (
    <div className={styles.gate} data-testid="terms-of-use-page">
      <TermsOfUseContent />
      <Checkbox
        className="mt-spacing-32"
        checked={isChecked}
        dataTestid="checkbox-accept-terms-of-use"
        label="I have read and accepted all the terms and conditions"
        value="terms-of-use"
        onChange={setIsChecked}
      />
      <div className={`${styles.actions} mt-spacing-32`}>
        <Button
          dataTestid="button-accept-terms-of-use"
          disabled={!isChecked}
          size="lg"
          text="Continue"
          variant={isChecked ? 'primary' : 'secondary'}
          onClick={handleAccept}
        />
        <Button
          size="lg"
          text="Decline"
          variant="secondary"
          onClick={() => {
            void navigate('/');
          }}
        />
      </div>
    </div>
  );
};

export default TermsOfUseGate;
